import { AlertCapabilities } from '@/store/modules/alertV2/configure/config-constant';
import i18n from '@/plugins/i18n';
import {
  COUCHBASE_BUCKET,
  COUCHBASE_CLUSTER,
  COUCHBASE_NODE,
  MYSQL_SUB,
  CASSANDRA_SUB,
  ORACLE_SUB,
  NODE,
  CASSASDRA_INSTANCE,
  ORACLE_INSTANCE,
  CUSTOMDB_QUERIES,
  POSTGRES_SUB,
  POSTGRES_INSTANCE,
  MSSQL_SUB,
  MSSQL_INSTANCE,
  CRITICAL,
  MAJOR,
  MINOR,
  CRITICAL_AND_MAJOR,
  CRITICAL_AND_MAJOR_AND_MINOR,
  SEVERITY_OPTIONS,
  MONGO_SUB,
  MONGO_INSTANCE,
  ANOMALY_COUNT,
} from '@/components/AlertsV2/constants';

export const Capability = Object.freeze({
  APM: 'APM',
  BROWSER: 'BROWSER',
  VM: 'VM',
  DATABASE: 'DATABASE',
  MOBILE: 'MOBILE',
  WSM: 'WSM',
  SM: 'SM',
  K8M: 'K8M',
  LOG: 'LOG',
  MQ: 'MQ',
  ANALYTICS: 'ANALYTICS',
  CAPABILITY_CLOUD: 'CAPABILITY_CLOUD',
});

export const Capabilities = Object.freeze({
  APM: 'APM',
  BROWSER: 'Browser monitoring',
  VM: 'VM monitoring',
  DATABASE: 'Database monitoring',
  MOBILE: 'Mobile monitoring',
  SM: 'Synthetic endpoint monitoring',
  K8M: 'Kubernetes monitoring',
  LOG: 'Log monitoring',
  MQ: 'MQ monitoring',
  CLOUD: 'Cloud monitoring',
  ANL: 'Analytics',
});

export const SymbolCapabilityMapper = Object.freeze({
  A: Capability.APM,
  B: Capability.BROWSER,
  D: Capability.DATABASE,
  K: Capability.K8M,
  M: Capability.MOBILE,
  S: Capability.SM,
  V: Capability.VM,
  L: Capability.LOG,
  Q: Capability.MQ,
  ANL: Capability.ANALYTICS,
  C: Capability.CAPABILITY_CLOUD,
});

export default class AlertsV2Utils {
  static CurrentAlertCapabilityValue(capability) {
    return getCurrentAlertCapabilityVal(capability);
  }

  static toMapCapability(capability) {
    return mapCapability(capability);
  }

  static toMapCapabilityName(capability) {
    return getCurrentAlertCapabilitylist(capability);
  }

  static toTitleCase(str) {
    return titleCase(str);
  }

  static filterKey(event) {
    return filterKey(event);
  }

  static filterKeyWithDecimalTwoDigits(event) {
    return filterKeyWithDecimalTwoDigits(event);
  }

  static CurrentAlertCapabilityFromVal(val) {
    return AlertCapabilities.find(
      (cap) => cap.key === SymbolCapabilityMapper[val],
    );
  }
}

function getCurrentAlertCapabilityVal(key) {
  switch (key) {
    case Capability.MOBILE:
      return 'M';
    case Capability.BROWSER:
      return 'B';
    case Capability.APM:
      return 'A';
    case Capability.VM:
      return 'V';
    case Capability.DATABASE:
      return 'D';
    case Capability.SM:
      return 'S';
    case Capability.WSM:
      return 'W';
    case Capability.K8M:
      return 'K';
    case Capability.LOG:
      return 'L';
    case Capability.MQ:
      return 'Q';
    case Capability.ANALYTICS:
      return 'ANL';
    case Capability.CAPABILITY_CLOUD:
      return 'C';
    default:
      return 'A';
  }
}

export function transformAndSortMetrics(data) {
  return data
    ?.map((item) =>
      item?.aggregation.includes(ANOMALY_COUNT)
        ? { ...item, icon: 'starFilled' }
        : item,
    )
    .sort((a, b) => (b?.icon === 'starFilled') - (a?.icon === 'starFilled'));
}

export function getCurrentSeverityForEditAlerts(severityVal) {
  const severityMap = {
    CRITICAL: SEVERITY_OPTIONS[0],
    MAJOR: SEVERITY_OPTIONS[1],
    // MINOR: SEVERITY_OPTIONS[2],
    MAJOR_CRITICAL: SEVERITY_OPTIONS[2],
    // MINOR_MAJOR_CRITICAL: SEVERITY_OPTIONS[4],
  };
  return severityMap[severityVal] || SEVERITY_OPTIONS[0];
}

export function getSeverityValueForLabel(sev) {
  const severityMessageMap = {
    [CRITICAL_AND_MAJOR]: i18n.global.t('alert.critical_major_sev_message'),
    // [CRITICAL_AND_MAJOR_AND_MINOR]: i18n.global.t(
    //   'alert.critical_major_minor_sev_message',
    // ),
    [CRITICAL]: i18n.global.t('alert.critcal_sev_message'),
    [MAJOR]: i18n.global.t('alert.major_sev_message'),
    // [MINOR]: i18n.global.t('alert.minor_sev_message'),
  };
  return sev?.key ? severityMessageMap[sev?.key] : severityMessageMap[CRITICAL];
}
function mapCapability(key) {
  let firstCapabilityMap;
  switch (key.toUpperCase()) {
    case 'M':
      return Capability.MOBILE;
    case 'B':
      return Capability.BROWSER;
    case 'A':
      return Capability.APM;
    case 'V':
      return Capability.VM;
    case 'D':
      return Capability.DATABASE;
    case 'S':
      return Capability.SM;
    case 'W':
      return Capability.WSM;
    case 'K':
      return Capability.K8M;
    case 'L':
      return Capability.LOG;
    case 'Q':
      return Capability.MQ;
    case 'ANL':
      return Capability.ANALYTICS;
    case 'C':
      return Capability.CAPABILITY_CLOUD;
    default:
      firstCapabilityMap = Object.values(Capability)[0];
  }
  return firstCapabilityMap;
}

function getCurrentAlertCapabilitylist(key) {
  switch (key) {
    case Capabilities.APM:
      return Capability.APM;
    case Capabilities.MOBILE:
      return Capability.MOBILE;
    case Capabilities.BROWSER:
      return Capability.BROWSER;
    case Capabilities.VM:
      return Capability.VM;
    case Capabilities.DATABASE:
      return Capability.DATABASE;
    case Capabilities.SM:
      return Capability.SM;
    case Capabilities.WSM:
      return Capability.WSM;
    case Capabilities.K8M:
      return Capability.K8M;
    case Capabilities.LOG:
      return Capability.LOG;
    case Capabilities.MQ:
      return Capability.MQ;
    case Capabilities.CLOUD:
      return Capability.CAPABILITY_CLOUD;
    case Capabilities.ANL:
      return Capability.ANALYTICS;
    default:
      Capability.APM;
  }
}

function titleCase(str) {
  return str.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
}

function filterKey(e) {
  var charCode = e.which ? e.which : e.keyCode;
  if (
    charCode > 31 &&
    charCode != 37 &&
    charCode != 39 &&
    (charCode < 48 || charCode > 57) &&
    (charCode < 96 || charCode > 105) &&
    charCode !== 46
  ) {
    e.preventDefault();
  }
  return true;
}

function filterKeyWithDecimalTwoDigits(evt) {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (
    charCode > 31 &&
    charCode != 37 &&
    charCode != 39 &&
    charCode != 190 &&
    charCode != 110 &&
    (charCode < 48 || charCode > 57) &&
    (charCode < 96 || charCode > 105) &&
    !(charCode == 46 || charCode == 8)
  ) {
    evt.preventDefault();
  }
  return true;
}

// TODO: Mapping nees to be handled from the backend
export const couchbaseMetricMapper = {
  // Bucket tyoe
  meter_couchbase_buckets_bucket_ops: COUCHBASE_BUCKET,
  meter_couchbase_buckets_bucket_disk_usage: COUCHBASE_BUCKET,
  meter_couchbase_buckets_bucket_mem_usage: COUCHBASE_BUCKET,
  meter_couchbase_buckets_bucket_current_items: COUCHBASE_BUCKET,
  meter_postgres_active_connections: COUCHBASE_NODE,

  // Cluster type
  meter_couchbase_clusters_cluster_mem_usage: COUCHBASE_CLUSTER,
  meter_couchbase_clusters_cluster_cpu_percent: COUCHBASE_CLUSTER,
  meter_couchbase_clusters_disk_size_used: COUCHBASE_CLUSTER,
  meter_couchbase_clusters_disk_size_total: COUCHBASE_CLUSTER,

  // node type
  meter_couchbase_nodes_query_request_active_count: COUCHBASE_NODE,
  meter_couchbase_nodes_query_request_completed_count: COUCHBASE_NODE,
  meter_couchbase_nodes_query_request_time_mean: COUCHBASE_NODE,
  meter_couchbase_nodes_query_request_time_median: COUCHBASE_NODE,
  meter_couchbase_nodes_query_request_time_95percentile: COUCHBASE_NODE,
  meter_couchbase_nodes_query_request_time_99percentile: COUCHBASE_NODE,
  meter_couchbase_nodes_query_total_threads: COUCHBASE_NODE,
  meter_couchbase_nodes_node_cpu_usage: COUCHBASE_NODE,
  meter_couchbase_nodes_node_ram_usage: COUCHBASE_NODE,
  meter_couchbase_nodes_node_swap_mem_used: COUCHBASE_NODE,
  meter_couchbase_nodes_node_ops: COUCHBASE_NODE,
  meter_couchbase_nodes_node_hits: COUCHBASE_NODE,
  meter_couchbase_nodes_node_cmdget: COUCHBASE_NODE,
  meter_couchbase_nodes_node_current_items: COUCHBASE_NODE,
  meter_couchbase_nodes_node_replica_items: COUCHBASE_NODE,
  meter_couchbase_nodes_node_docs_data_size: COUCHBASE_NODE,
  meter_couchbase_nodes_node_mcd_mem_allocated: COUCHBASE_NODE,
  meter_couchbase_nodes_gcnum: COUCHBASE_NODE,
};

export const dbTypeMapper = {
  [MYSQL_SUB]: NODE,
  [ORACLE_SUB]: ORACLE_INSTANCE,
  [CASSANDRA_SUB]: CASSASDRA_INSTANCE,
  [POSTGRES_SUB]: POSTGRES_INSTANCE,
  [MSSQL_SUB]: MSSQL_INSTANCE,
  [MONGO_SUB]: MONGO_INSTANCE,
};

export const customDBTypeMapper = {
  [MYSQL_SUB]: NODE,
  [POSTGRES_SUB]: POSTGRES_INSTANCE,
  [MSSQL_SUB]: MSSQL_INSTANCE,
};

export const customStylesForSelectField = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'spaceBetween',
  alignItems: 'center',
  height: '100%',
};

export const configuredAlertSortMapping = {
  ruleName: 'ruleName',
  metricDisplayName: 'metricDisplayName',
  aggType: 'aggregationType',
  totalAlerts: 'totalAlerts',
  lastUpdatedAt: 'lastUpdatedAt',
};

export const generatedAlertSortMapping = {
  alertName: 'ruleName',
  metric: 'metricDisplayName',
  totalAlertOccurrences: 'totalAlertOccurrences',
  occurrences: 'occurrences',
  latestOccurrence: 'endTimestamp',
  triggeredOn: 'startTimestamp',
};
